export enum AppSubscriptionStatusEnum {
    InComplete = 'in_complete',
    InCompleteExpired = 'in_complete_expired',
    Active = 'active',
    Cancelled = 'cancelled',
    Trailing = 'trailing',
    Open = 'open',
}
